import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import AIChatPage from "./pages/AIChatPage";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<AIChatPage />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;
